import { useEffect, useMemo, useState } from "react";

/**
 * Floating fire embers — pure CSS animation, transform/opacity only.
 * Fewer particles on mobile for smoothness.
 */
export default function Embers({ count, className = "" }) {
  const [mobile, setMobile] = useState(
    () => window.matchMedia("(max-width: 767px)").matches
  );

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 767px)");
    const onChange = (e) => setMobile(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  const n = count ?? (mobile ? 7 : 14);

  const embers = useMemo(
    () =>
      Array.from({ length: n }, (_, i) => {
        const size = 2.5 + Math.random() * 4;
        return {
          id: i,
          size,
          left: Math.random() * 100,
          delay: -(Math.random() * 16),
          duration: 11 + Math.random() * 9,
          drift: (Math.random() - 0.5) * 120,
          opacity: 0.3 + Math.random() * 0.35,
        };
      }),
    [n]
  );

  return (
    <div
      className={`pointer-events-none absolute inset-0 z-[5] overflow-hidden ${className}`}
      aria-hidden="true"
      data-testid="embers-layer"
    >
      {embers.map((e) => (
        <span
          key={e.id}
          className="ember"
          style={{
            width: e.size,
            height: e.size,
            left: `${e.left}%`,
            "--ember-delay": `${e.delay}s`,
            "--ember-d": `${e.duration}s`,
            "--ember-x": `${e.drift}px`,
            "--ember-o": e.opacity,
          }}
        />
      ))}
    </div>
  );
}
